// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"6ab2ef5e","189":"c7e774a1","250":"2b11026b","756":"620ffb4d","767":"4708762f","856":"b082ff30","995":"6f38e02b","999":"57c62ba8"}[chunkId] + ".chunk.js";
};